import {
  Component,
  Injectable,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { ScoreService } from '../../../../common/services/Score.service';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CqFileService } from 'app/common/services/CqFile.service';
import { BsModalService } from 'ngx-bootstrap';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { CqCriteriaService } from 'app/common/services/CqCriteria.service';
import { CqFileLogService } from 'app/common/services/CqFileLog.service';
import { CqScriptService } from 'app/common/services/CqScript.service';

@Component({
  moduleId: module.id,
  selector: 'score-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.css'],
  providers: [ScoreService, BsModalService, CqFileService, CqCriteriaService, CqFileLogService, CqScriptService],
})
@Injectable()
export class DetailComponent implements OnInit {
  @Output('backScoreMode') backScoreMode = new EventEmitter();
  @Input() score_id;
  @ViewChild('commentContainer') commentContainer: ElementRef;
  public list: any = [];
  public page_size = 10;
  public currentPage = 1;
  totalItem: any = 0;
  totalPage: any = 0;
  public selected: any = {};
  public is_check_all = false;
  public have_check = false;
  public fileLogs: any = [];
  // new clone
  public scoreLayout: any = 'keyword';
  responseData: any;
  public call_detail: any = {};
  public interval: any;
  public call_comment: any = '';
  public user: any = null;
  public detailResult: any = null;
  public criterias: any = [];
  public listScripts: any = [];
  public curentScript: any = {};
  public totalGroup: any = {
    totalScore: 0,
    totalPercent: 0,
    status: 'Chưa đạt',
  };
  public selectedData: any = {};
  public scrollPosition = 0;
  public showDetailScore = false;
  // public totalScore:any = 0;
  // public totalPercent:any = 0;

  constructor(
    private cqFile: CqFileService,
    private cqCriteria: CqCriteriaService,
    private toastr: ToastrService,
    private cqFileLog: CqFileLogService,
    private cqScript: CqScriptService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {}

  scrollToBottom(): void {
    setTimeout(() => {
      this.commentContainer.nativeElement.scrollTop = this.commentContainer.nativeElement.scrollHeight;
    }, 0);
  }

  postComment() {
    if (!this.call_comment || (this.call_comment && this.call_comment.trim() != '')) {
      console.log(this.call_detail.comment, 'this.call_detail.user_comment2222');
      const payload = {
        user_comment: [
          ...this.call_detail.comment,
          {
            user_name: this.user ? this.user.name : 'Anonymous',
            text: this.call_comment,
            created_at: new Date(),
          },
        ],
      };
      this.cqFile.update(this.call_detail.ai_data_task_id, payload).subscribe(res => {
        this.call_detail.comment = payload.user_comment.map(e => {
          return {
            ...e,
            created_at_trans: moment(e.created_at).format('YYYY-MM-DD HH:mm:ss'),
          };
        });
        this.scrollToBottom();
      });

      this.call_comment = '';
    } else {
      this.toastr.error('Nhận xét không được bỏ trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loadData();
    }, 1000);
  }

  reload() {
    setTimeout(() => {
      this.loadData();
    }, 1000);
  }

  changeTab(value) {
    console.log(value, 'value');
    this.scoreLayout = value;
    if (value == 'comment') {
      this.scrollToBottom();
    }
  }

  reanalysis() {
    const body = {
      id_text: this.detailResult.ai_data_task_id,
      id_categories: '1',
      id_keywords: '1',
      id_form: '65bb57b6f11f6e31a6df6fb0',
      id_score_criteria: '65bcc91a391821738460a494',
      webhook: 'https://api.1contact.vn/callquality/webhook2',
    };

    this.cqFile.reanalysis(body).subscribe(res => {
      if (res.error) {
        this.toastr.error('Có lỗi khi tải dữ liệu, vui lòng thử lại sau', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      } else {
        this.toastr.success('Đã gửi yêu cầu phân tích lại', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.loadData();
      }
    });
  }

  postPoint() {
    let check = false;
    this.detailResult.criterias.forEach(items => {
      if (!items.userScore || items.userScore < 0 || items.userScore > items.maxscore) {
        return (check = true);
      }
    });
    if (check) {
      return this.toastr.error('Điểm số không hợp lệ', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    const body = {
      result_score_criteria: this.detailResult.criterias.map(value => {
        return {
          id: value.id,
          result: value.userScore,
        };
      }),
      task_id: this.detailResult.ai_data_task_id,
      file_id: this.detailResult.id,
    };

    this.cqFileLog.create(body).subscribe(res => {
      this.toastr.success('Đã cập nhật điểm số', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      this.loadData();
    });
  }

  loadData() {
    clearInterval(this.interval);
    this.cqScript.list().subscribe(res => {
      this.listScripts = res.data.list;
    });
    this.cqFileLog.list({ file_id: this.score_id }).subscribe(res => {
      this.fileLogs = res.data.list;
      this.fileLogs = this.fileLogs
        .map(value => {
          this.listScripts.map(e => {
            if (e._id == value.script_id) {
              this.curentScript = e;
              value.script_name = e.name;
              value.script_maxscore = e.maxscore;
              value.normal_score = e.normal_score;
              value.good_score = e.good_score;
            }
          });
          value.showingdesc = false;
          value.createAt = moment(value.createdAt).format('YYYY-MM-DD HH:mm:ss');
          let score = 0;
          if (value.result && value.result.id_score_criteria && value.result.id_score_criteria.length) {
            value.result.id_score_criteria.map(item => {
              if (item.result) {
                score += Number(item.result);
              }
            });
          }
          value.score = score;
          value.percent = ((value.score / value.script_maxscore) * 100).toFixed(1);
          value.status =
            Number(value.percent) < Number(value.normal_score)
              ? 'Chưa đạt'
              : Number(value.percent) < Number(value.good_score)
                ? 'Trung bình'
                : 'Đạt';

          return value;
        })
        .sort((a, b) => b.createAt - a.createAt);
      console.log(this.curentScript, ' this.curentScript');
      this.cqCriteria.list().subscribe(res => {
        this.criterias = res.data.list;
      });
      console.log(this.fileLogs);
      this.cqFile.find(this.score_id).subscribe(res => {
        if (!res.error) {
          if (res.data && res.data.result) {
            this.detailResult = {
              type: res.data.type,
              id: res.data._id,
              createAt: moment(res.data.createAt).format('YYYY-MM-DD HH:mm:ss'),
              ai_data_task_id: res.data.ai_data_task_id,
            };
            if (res.data.result.id_form && res.data.result.id_form.list_fields) {
              this.detailResult = {
                ...this.detailResult,
                forms: res.data.result.id_form.list_fields,
              };
            }
            if (res.data.result.id_keywords && res.data.result.id_keywords.list_keys) {
              this.detailResult = {
                ...this.detailResult,
                keywords: res.data.result.id_keywords.list_keys,
              };
            }
            if (res.data.result.id_categories && res.data.result.id_categories.categories) {
              this.detailResult = {
                ...this.detailResult,
                categories: res.data.result.id_categories.categories.filter(value => value.result == 'Đúng'),
              };
            }
            if (res.data.result.id_score_criteria) {
              const scoreAutolist = this.fileLogs
                .filter(value => value.type == 0)
                .sort((a, b) => a.createAt - b.createAt)[0] || {
                result: { id_score_criteria: [] },
              };
              const scoreManuallist = this.fileLogs
                .filter(value => value.type == 1)
                .sort((a, b) => a.createAt - b.createAt)[0] || {
                result: { id_score_criteria: [] },
              };
              console.log(scoreAutolist, 'scoreAutolist');
              console.log(scoreManuallist, 'scoreManuallist');

              this.detailResult = {
                ...this.detailResult,
                criterias: res.data.result.id_score_criteria.map(value => {
                  this.criterias.map(item => {
                    if (value.id == item._id) {
                      value.scoreAutolist = scoreAutolist;
                      value.scoreManuallist = scoreManuallist;
                      value.name = item.name;
                      value.maxscore = item.maxscore;
                    }
                  });
                  scoreAutolist.result.id_score_criteria.map(itemv1 => {
                    if (itemv1.id == value.id) {
                      value.olduserscoreAuto = itemv1.result;
                    }
                  });

                  scoreManuallist.result.id_score_criteria.map(itemv2 => {
                    if (itemv2.id == value.id) {
                      value.olduserscoreManual = itemv2.result;
                    }
                  });
                  return value;
                }),
              };
            }
            console.log(this.detailResult, ' this.detailResult');
          }
          this.call_detail = _.assign({}, res.data);
          $('#cq_audio_html').attr('src', this.call_detail.file_path);
          if (!this.call_detail.content) {
            return null;
          }
          this.call_detail.createAt = moment(this.call_detail.createAt).format('YYYY-MM-DD HH:mm:ss');
          this.call_detail.audioTime = Math.floor(this.call_detail.content[this.call_detail.content.length - 1].start);
          for (let i = 0; i < this.call_detail.content.length; i++) {
            this.call_detail.content[i].startFloor = Math.floor(this.call_detail.content[i].start);
          }
          if (!this.call_detail.user_comment || !this.call_detail.user_comment.length) {
            this.call_detail.comment = [];
          } else {
            console.log(this.call_detail.user_comment, 'this.call_detail.user_comment');
            this.call_detail.comment = this.call_detail.user_comment.map(e => {
              e.created_at_trans = moment(e.created_at).format('YYYY-MM-DD HH:mm:ss');
              return e;
            });
          }
        } else {
          this.toastr.error('Có lỗi khi tải dữ liệu, vui lòng thử lại sau', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
    });
  }

  calculateTotalScore() {
    this.totalGroup.totalScore = this.detailResult.criterias.reduce((acc, curr) => acc + (curr.userScore || 0), 0);
    this.totalGroup.totalPercent = ((this.totalGroup.totalScore / this.curentScript.maxscore) * 100).toFixed(2);
    this.totalGroup.status =
      Number(this.totalGroup.totalPercent) < Number(this.curentScript.normal_score)
        ? 'Chưa đạt'
        : Number(this.totalGroup.totalPercent) < Number(this.curentScript.good_score)
          ? 'Trung bình'
          : 'Đạt';
  }

  backToList() {
    this.pauseAudio();
    clearInterval(this.interval);
    this.backScoreMode.emit({
      scoreMode: 'list',
    });
  }

  pauseAudio() {
    const audio = document.getElementById('cq_audio_html');
    if (audio) {
      (<any>audio).pause();
      clearInterval(this.interval);
    }
  }

  adjustAudio(time) {
    this.scrollPosition = 0;
    const audio = document.getElementById('cq_audio_html');
    if (audio) {
      (<any>audio).currentTime = time;
      (<any>audio).play();
    }
  }

  onPlayAudio() {
    if (this.call_detail) {
      clearInterval(this.interval);
      const audio: any = document.getElementById('cq_audio_html');
      const detail = this.call_detail;
      const interval_time = 1000 / audio.playbackRate;
      this.interval = setInterval(() => {
        const time = audio.currentTime;
        for (let i = 0; i < detail.content.length; i++) {
          const content = detail.content[i];
          if (content.start <= time && content.end >= time) {
            content.selected = true;
          } else {
            content.selected = false;
          }
          if (i > 2 && content.selected == true) {
            if (this.scrollPosition >= 300) {
              const activeElement = document.querySelector('.activev2') as HTMLElement;
              let scrollToPositionActive = 0;
              if (activeElement) {
                scrollToPositionActive = activeElement.offsetTop - 150;
              }
              const checking = Math.abs(this.scrollPosition - Number(scrollToPositionActive));
              if (checking < 400) {
                document
                  .getElementById('audio-container')
                  .scrollTo(0, document.getElementById('audio-content-' + i).offsetTop - 150);
                this.scrollPosition = 0;
              }
              return null;
            } else {
              document
                .getElementById('audio-container')
                .scrollTo(0, document.getElementById('audio-content-' + i).offsetTop - 150);
              this.scrollPosition = 0;
            }
          }
        }
      }, interval_time);
    }
  }
  onScroll(event) {
    this.scrollPosition = Number((event.target as HTMLElement).scrollTop);
  }

  onPauseAudio() {
    console.log('Pause');
    this.scrollPosition = 0;
    clearInterval(this.interval);
  }

  onEndedAudio() {
    const audio: any = document.getElementById('cq_audio_html');
    console.log('Ended');
    clearInterval(this.interval);
  }

  onRateChange() {
    const audio: any = document.getElementById('cq_audio_html');
    this.onPlayAudio();
  }

  handleShowDesc(data) {
    this.selectedData = data;
    this.fileLogs.map(value => {
      if (value._id == data._id) {
        value.showingdesc = !value.showingdesc;
        if (value.result && value.result.id_score_criteria) {
          value.descs = value.result.id_score_criteria.map(item => {
            const obj = { maxscore: 0, name: '', result: item.result };
            value.currentScript.map(b => {
              if (b.id == item.id) {
                obj.maxscore = b.maxscore;
              }
            });
            this.criterias.map(c => {
              if (c._id == item.id) {
                obj.name = c.name;
              }
            });
            return obj;
          });
        }
      } else {
        value.showingdesc = false;
      }
    });
    console.log(this.fileLogs, '--------------this.fileLogs');
  }

  longestCommonSubstring(str1, str2) {
    const n = str1.length;
    const m = str2.length;

    const lcs = [];
    for (let i = 0; i <= n; i++) {
      lcs[i] = [];
      for (let j = 0; j <= m; j++) {
        lcs[i][j] = 0;
      }
    }

    let result = '';
    let max = 0;
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < m; j++) {
        if (str1[i] === str2[j]) {
          lcs[i + 1][j + 1] = lcs[i][j] + 1;
          if (lcs[i + 1][j + 1] > max) {
            max = lcs[i + 1][j + 1];
            result = str1.substring(i - max + 1, i + 1);
          }
        }
      }
    }
    return result;
  }

  hasSubArray(master, sub) {
    return sub.every(
      (
        i => v =>
          (i = master.indexOf(v, i) + 1)
      )(0)
    );
  }

  searchAndScroll(value) {
    this.pauseAudio();
    setTimeout(() => {
      if (value) {
        value = value.toLowerCase();
      }
      const tmp1 = value.split(' ');
      let longest = 0;
      let longest_match_text = '';
      let pos_to_scroll = null;
      // Lặp vòng đầu tiên để tìm câu thoại có chứa từ khóa gần đúng nhất
      for (let i = 0; i < this.call_detail.content.length; i++) {
        this.call_detail.content[i].selected = false; // bỏ đánh dấu các câu thoại đã tìm kiếm trước đó
        const audio_text = $('#audio-content-' + i)
          .text()
          .trim()
          .toLowerCase();
        const matched_text = this.longestCommonSubstring(audio_text, value);
        let tmp2 = matched_text.split(' ');
        tmp2 = tmp2.filter(e => e);
        if (this.hasSubArray(tmp1, tmp2) && tmp2.length >= longest) {
          longest = tmp2.length;
          longest_match_text = tmp2.join(' ');
          if (audio_text.indexOf(longest_match_text) >= 0) {
            pos_to_scroll = i;
          }
        }
      }
      if (pos_to_scroll !== null) {
        this.call_detail.content[pos_to_scroll].selected = true;
        const audio = document.getElementById('cq_audio_html');
        if (audio) {
          (<any>audio).currentTime = this.call_detail.content[pos_to_scroll].startFloor;
        }
        document
          .getElementById('audio-container')
          .scrollTo(0, document.getElementById('audio-content-' + pos_to_scroll).offsetTop - 150);
      }
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/score/detail.component.ts